module.exports = "import React from 'react';\n\nimport Tag from '@atlaskit/tag';\n\nexport default (): React.JSX.Element => <Tag text=\"Design\" />;\n"